import React, { useContext } from 'react'
import Panel from '../Panel/Panel'
import useTabs from './useTabs'
import {
    Route,
    // Routes
} from 'react-router-dom'
export interface TabContentProps {
    id: string | number
    withPanel?: boolean
    children?: any
}
const TabContent: React.FC<TabContentProps> = ({ id, children, withPanel }) => {
    const { current, withRoute, getTab } = useTabs()

    if (withRoute) {
        const tab = getTab(id) || {}
        const path = tab.path
        if (!path) {
            return null
            // throw Error('Tab Content could not find a path for tab id ' + id)
        }
        // @ts-ignore
        return (
            // <Routes>
            //@ts-ignore
            <Route path={path} render={() => children} />
            // <Route path={path} component={children} />
            // <Route path={path} element={() => children} />
            // </Routes>
        )
    }

    if (current !== id) {
        return null
    }

    if (withPanel) {
        return <Panel>{children}</Panel>
    }

    return children
}

export default TabContent
